export default __webpack_public_path__ + "c0b8e9c1c0b088d9109991458c1c6b73.svg";